<template>
    <div class="form-result-container">
        <div class="form-result-card">
            <div class="success-icon">
                <i class="fa fa-check-circle"></i>
            </div>

            <div v-if="this.siteInfo && this.siteInfo.LogoUrl" class="logo-container">
                <img class="logo" :src="siteInfo.LogoUrl"/>
            </div>

            <h2 class="thank-you-title">Thank You!</h2>

            <div class="success-message">
                <p>Your form has been successfully submitted.</p>
            </div>

            <!-- SMS Consent Confirmation (only shown for SMS consent forms) -->
            <div v-if="isSmsConsentForm" class="sms-confirmation">
                <div class="sms-confirmation-icon">
                    <i class="fa fa-mobile"></i>
                </div>
                <h3 class="sms-confirmation-title">SMS Text Message Enrollment Confirmed</h3>
                <p class="sms-confirmation-text">
                    You have opted in to receive text messages from
                    <strong>{{ practiceName }}</strong>, including appointment reminders and care updates.
                </p>
                <ul class="sms-details">
                    <li><i class="fa fa-comment"></i> Message frequency: Up to 4 messages per month</li>
                    <li><i class="fa fa-dollar-sign"></i> Message and data rates may apply</li>
                    <li><i class="fa fa-ban"></i> Reply <strong>STOP</strong> to opt out at any time</li>
                    <li><i class="fa fa-question-circle"></i> Reply <strong>HELP</strong> for assistance</li>
                </ul>
            </div>

            <div class="close-message">
                <p>You may now close this window.</p>
            </div>

            <div class="site-details">
                <span v-html="this.getSiteDetails(this.siteInfo.SiteID)"></span>
            </div>
        </div>
        <PoweredByFooter />
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import PoweredByFooter from '@/components/PoweredByFooter.vue';

    export default {
        name: "FormResult",
        components: { PoweredByFooter },
        props: ['logoUrl', 'siteInfo', 'formConfig'],

        async created() {
        },

        data: () => ({
            test: null,
        }),

        methods: {
            getSiteDetails() {
                let retVal = '';

                    if(this.siteInfo) {
                        // The logo is rendered (size-capped) in the template above — never as an
                        // uncapped <img> inside this v-html string.
                        if(this.siteInfo.Name && this.siteInfo.Name.trim() !== '')
                            retVal = `${this.siteInfo.Name}`;

                        if(this.siteInfo.Address1 && this.siteInfo.Address1.trim() !== '') {
                            retVal = retVal + `<br>${this.siteInfo.Address1}`;

                            if(this.siteInfo.Address2 && this.siteInfo.Address2.trim() !== '')
                                retVal = retVal + `<br>${this.siteInfo.Address2}`;

                            retVal = retVal + `<br>${this.siteInfo.City},${this.siteInfo.State} ${this.siteInfo.Zip}`;
                        }

                        if(this.siteInfo.OfficePhone && this.siteInfo.OfficePhone.trim() !== '') {
                            retVal = retVal + `<br>Phone: ${this.siteInfo.OfficePhone}`;
                        }
                    }


                return retVal;
            }

        },

        computed: {
            ...mapState({
                sites: state => state.customer.sites,
            }),

            /**
             * Check if this form was an SMS consent form
             */
            isSmsConsentForm() {
                return this.formConfig && this.formConfig.smsConsentForm === true;
            },

            /**
             * Get the practice name from siteInfo
             */
            practiceName() {
                if (this.siteInfo && this.siteInfo.Name && this.siteInfo.Name.trim() !== '') {
                    return this.siteInfo.Name;
                }
                return 'this practice';
            },

        }

    }

</script>

<style scoped>
.form-result-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    min-height: 100vh;
    padding: 20px;
    background-color: #f8f9fa;
}

.form-result-card {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    padding: 40px;
    max-width: 600px;
    width: 100%;
    text-align: center;
    position: relative;
}

.success-icon {
    font-size: 60px;
    color: #28a745;
    margin-bottom: 20px;
}

.logo-container {
    margin-bottom: 20px;
    text-align: center;
}

.logo {
    display: inline-block;
    width: auto;
    max-width: 200px;
    /* max-height + contain: a square/portrait LogoUrl (an 800x800 photo has shipped) must not
       grow to 200x200 here. Same band as VerifyForm/ViewForm. Pinned by
       cypress/node-tests/logo-size-cap-guardrail.test.js. */
    max-height: 80px;
    height: auto;
    object-fit: contain;
}

.thank-you-title {
    font-size: 32px;
    color: #333;
    margin-bottom: 20px;
}

.success-message {
    font-size: 18px;
    color: #555;
    margin-bottom: 10px;
    line-height: 1.5;
}

.close-message {
    font-size: 16px;
    color: #777;
    margin-top: 20px;
    margin-bottom: 10px;
}

/* SMS Consent Confirmation Styles */
.sms-confirmation {
    background-color: #f0f7ff;
    border: 1px solid #cce0ff;
    border-radius: 8px;
    padding: 25px;
    margin: 20px 0;
    text-align: left;
}

.sms-confirmation-icon {
    text-align: center;
    font-size: 36px;
    color: #0066cc;
    margin-bottom: 12px;
}

.sms-confirmation-title {
    font-size: 20px;
    color: #0066cc;
    margin-bottom: 12px;
    text-align: center;
}

.sms-confirmation-text {
    font-size: 15px;
    color: #444;
    line-height: 1.6;
    margin-bottom: 16px;
}

.sms-details {
    list-style: none;
    padding: 0;
    margin: 0 0 16px 0;
}

.sms-details li {
    font-size: 14px;
    color: #555;
    padding: 6px 0;
    border-bottom: 1px solid #e0ecf7;
}

.sms-details li:last-child {
    border-bottom: none;
}

.sms-details li i {
    color: #0066cc;
    width: 20px;
    margin-right: 8px;
    text-align: center;
}

.site-details {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}

/* Mobile responsive styles */
@media (max-width: 576px) {
    .form-result-card {
        padding: 30px 20px;
    }

    .success-icon {
        font-size: 50px;
    }

    .thank-you-title {
        font-size: 26px;
    }

    .success-message {
        font-size: 16px;
    }

    .sms-confirmation {
        padding: 18px;
    }

    .sms-confirmation-title {
        font-size: 18px;
    }
}
</style>
